import {
  Combobox,
  ComboboxContent,
  ComboboxInput,
  ComboboxItem,
  ComboboxLabel,
} from '@firstbite/ui'

import type { AgentMeta } from './agentTypeMetadata'

interface Props {
  agentTypes: AgentMeta[]
  selected: string | null
  // Null when the field is cleared — restores the old Select's deselect-to-empty.
  onSelect: (agentType: string | null) => void
}

export function AgentTypeSelect({ agentTypes, selected, onSelect }: Props) {
  return (
    <Combobox
      selectedKey={selected ?? null}
      onSelectionChange={(key) => {
        onSelect(key != null ? String(key) : null)
      }}
    >
      <ComboboxLabel>Column Type</ComboboxLabel>
      <ComboboxInput placeholder="Select a column type…" />
      <ComboboxContent emptyMessage="No column types found.">
        {agentTypes.map((agent) => (
          <ComboboxItem
            key={agent.agent_type}
            id={agent.agent_type}
            // Rich two-line row, but the input echoes this string on select.
            textValue={agent.name}
          >
            <div className="flex flex-col whitespace-normal">
              <span className="font-medium">{agent.name}</span>
              <span className="text-xs text-fbui-gray-500">
                {agent.description}
              </span>
            </div>
          </ComboboxItem>
        ))}
      </ComboboxContent>
    </Combobox>
  )
}
